import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { SubscriptionCard } from './SubscriptionCard';
import { Wrapper, TagTitle, TagSection } from './SubscriptionSelectionModal.styles';

import { useMySubscriptions } from '@/store';

export const SubscriptionSelectionModal = () => {
  const { isOpen, subscriptionsByTag, setIsOpen } = useMySubscriptions();
  const { t } = useTranslation('StudentDashboardTranslations');
  return (
    <Modal
      title={t('MY_COURSES')}
      styles={{
        body: {
          maxHeight: '60vh',
          overflowY: 'auto',
          padding: '24px'
        }
      }}
      width={900}
      centered
      closable={true}
      onCancel={() => setIsOpen(false)}
      open={isOpen}
      footer={null}>
      <div>
        {Object.entries(subscriptionsByTag)
          .sort(([tagA], [tagB]) => tagA.localeCompare(tagB))
          .map(([tagName, subscriptions]) => (
            <TagSection key={tagName}>
              <TagTitle>{tagName}</TagTitle>
              <Wrapper>
                {subscriptions
                  .sort((a, b) => a.course.name.localeCompare(b.course.name))
                  .map(subscription => (
                    <SubscriptionCard key={subscription._id} subscription={subscription} />
                  ))}
              </Wrapper>
            </TagSection>
          ))}
      </div>
    </Modal>
  );
};
